module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_extra_heart.4d0fd6df.png";